<template>
  <v-container>
    <v-dialog v-model="showDialog" scrollable max-width="90%" :retain-focus="false">
      <!--<v-skeleton-loader v-if="loading" type="article, actions" />-->
      <v-card>
        <v-card-title>
          <v-panel>
            <span style="font-size: 20px;">
              {{ $t("wkt.admin.projects.calendar-wizard.title") }}
            </span>
            <!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="showDialog=false">close</v-icon>
						</v-btn>-->
          </v-panel>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="mx-0 pa-4 pb-2" @wheel="onWheel">
            <v-form ref="form">
              <v-row>
                <span style="font-size: 16px; font-weight: bold; color: #424242;">{{ $t('wkt.admin.projects.project.title_1') }}</span>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-radio-group row v-model="workdayDelete">
                    <v-radio
                      :label="$t('wkt.admin.projects.project.schedule_action.establish')"
                      :value="false"
                    />
                    <v-radio
                      :label="$t('wkt.admin.projects.project.schedule_action.delete')"
                      :value="true"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              
                <v-row v-if="workdayDelete == false">
                  <span style="font-size: 16px; font-weight: bold; color: #424242;">{{ $t('wkt.admin.projects.project.title_2') }}</span>
                </v-row>
                <v-row class="py-0" v-if="workdayDelete == false">
                  <v-col cols="12">
                    <v-radio-group
                      row
                      v-model="planningType"
                      class="mt-0 pa-0"
                    >
                      <v-radio
                        :label="$t('wkt.admin.projects.calendar-wizard.assistant_mode_simple')"
                        :value="1"
                      />
                      <v-radio
                        :label="getPlanningTypeBySectionsText"
                        :value="0"
                        :disabled="!enableAdvancedPlanning"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                <span style="font-size: 16px; font-weight: bold; color: #424242;">{{ $t('wkt.admin.projects.project.title_3') }}</span>
              </v-row>
                  <v-row class="d-flex justify-start py-0">
                    <v-col cols="2">
                      <v-menu
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="fromDateFormatted"
                            :label="$t('wkt.admin.projects.calendar-wizard.start_date_placeholder')"
                            readonly
                            v-on="on"
                            dense
                          />
                        </template>
                        <v-date-picker
                          v-model="fromDateIso"
                          no-title
                          scrollable
                          :first-day-of-week="1" 
                          :locale="$i18n.locale"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="2">
                      <v-menu
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="toDateFormatted"
                            :label="$t('wkt.admin.projects.calendar-wizard.end_date_placeholder')"
                            readonly
                            v-on="on"
                            v-bind="attrs"
                            dense
                            :error-messages="errorMessages"
                          />
                        </template>
                        <v-date-picker
                          v-model="toDateIso"
                          no-title
                          scrollable
                          :first-day-of-week="1" 
                          :locale="$i18n.locale"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

              </v-row>
                <!-- Template para "Por días" -->
                <v-row class="mt-0" v-if="planningType === constants.SHIFT_PLANNER_BY_DAYS" >
                  <v-col cols="9" class="pb-1 pt-0 d-flex flex-row align-center justify-space-between">
                    <div class="d-flex align-center">
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="L"
                        :label="weekdays[1]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="M"
                        :label="weekdays[2]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="X"
                        :label="weekdays[3]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="J"
                        :label="weekdays[4]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="V"
                        :label="weekdays[5]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="S"
                        :label="weekdays[6]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                      <v-checkbox
                        v-model="selectedWeekdays"
                        value="D"
                        :label="weekdays[0]"
                        class="mt-0 mr-2 text-capitalize"
                        hide-details
                      />
                    </div>

                    <v-text-field
                          v-model="byDays[0].periodicityInWeeks"
                          :rules="[validationRules.required, validationRules.minValue(1)]"
                          :label="$t('wkt.admin.projects.calendar-wizard.periodicity')"
                          type="number"
                          class="ml-2 mt-n2"
                          style="max-width: 200px; min-width: 120px"
                          min="1"
                          max="52"
                        ></v-text-field>
                    </v-col> 
                      <v-col
                        cols="12"
                        class="ma-0 mb-2 pa-0 px-4"
                        style="height: 12px; font-size: 12px;"
                      >
                        <span class="error--text">{{ weekdaysErrorMessage }}</span>
                      </v-col>
                </v-row>
                <v-row v-if="workdayDelete == false">
                <span style="font-size: 16px; font-weight: bold; color: #424242;">{{ $t('wkt.admin.projects.project.title_4') }}</span>
              </v-row>
                <v-row v-if="planningType === constants.SHIFT_PLANNER_BY_DAYS && workdayDelete == false">
                  <v-col cols="12" class="d-flex justify-between" style="gap: 20px;">
                    <v-autocomplete
                      attach
                      v-model="byDays[0].project"
                      :items="projects"
                      item-text="shortName"
                      item-value="id"
                      :rules="[validationRules.required]"
                      :label="$t('wkt.admin.projects.calendar-wizard.project_title')"
                      class=""
                      allow-overflow
                      style="max-width: 500px; min-width: 100px;"
                    />
                    <v-autocomplete
                      attach
                      v-model="byDays[0].calendar"
                      :items="calendars"
                      item-text="name"
                      item-value="id"
                      :rules="[validationRules.required]"
                      :label="$t('wkt.admin.projects.calendar-wizard.calendar_title')"
                      class=""
                      allow-overflow
                      style="max-width: 500px; min-width: 100px;"
                    />
                    <v-autocomplete
                      attach
                      v-model="byDays[0].workplace"
                      :items="workplaces"
                      item-text="name"
                      item-value="id"
                      :rules="[validationRules.required]"
                      :label="$t('wkt.admin.projects.calendar-wizard.workplace_title')"
                      class=""
                      allow-overflow
                      style="max-width: 500px; min-width: 100px;"
                    />
                  </v-col>
                  <v-col cols="12" class="mx-1">
                    <v-text-field
                      v-model="byDaysNotes"
                      :label="$t('wkt.admin.projects.calendar-wizard.company-notes')"
                      autocomplete="none"
                      maxLength="200"
                      counter="200"
                      style="padding-top: 0;"
                    />
                  </v-col>
                </v-row>
                <!-- Template para "Por tramos" -->
                <v-container fluid>
                  <v-row
                    v-if="planningType === constants.SHIFT_PLANNER_BY_SECTIONS && workdayDelete == false"
                  >
                    <v-col cols="12" class="px-0 d-flex justify-end">                      
                      <v-btn text color="#185EA9" @click="addSection()">
                        <v-icon class="mr-1">add_circle_outline</v-icon>
                        {{ $t("wkt.admin.projects.calendar-wizard.add_section") }}
                      </v-btn>
                    </v-col>
                    <!-- NUEVO -->
                    <v-col cols="12" class="mb-4 pa-0">
                      <v-data-table
                        :headers="headers"
                        :items="bySections"
                        :loading-text="$t('wkt.admin.common.table.loading')"
                        :no-data-text="$t('wkt.admin.common.table.no_data')"
                        :no-results-text="$t('wkt.admin.common.table.no_results')"
                        fixed-header
                        disable-pagination
                        hide-default-footer
                        checkbox-color="#185EA9"
                        calculate-widths
                        height="auto"
                        class="elevation-0"
                      >
                        <template v-slot:[`item.project`]="{ item }">
                          {{ getProjectNameBySection(item.project) }}
                        </template>
                        <template v-slot:[`item.calendar`]="{ item }">
                          {{ getCalendarNameBySection(item.calendar) }}
                        </template>
                        <template v-slot:[`item.workplace`]="{ item }">
                          {{ getWorkplaceNameBySection(item.workplace) }}
                        </template> 
                        <template v-slot:[`item.notes`]="{ item }">
                          <p v-html="formatNotes(item.notes)" class="mb-0"></p>
                        </template>                       
                        <template v-slot:[`item.actions`]="{ item, index }">
                          <v-btn 
                            text 
                            color="#185EA9" 
                            :disabled="loading || index === 0" 
                            style="min-width: 36px; padding: 0;"
                            @click="swapSections(bySections[index-1], index-1, item, index)">
                            <v-icon color="#185EA9">arrow_upward</v-icon>
                          </v-btn>
                          <v-btn 
                            text 
                            color="#185EA9" 
                            :disabled="loading || index === bySections.length-1" 
                            style="min-width: 36px; padding: 0;"
                            @click="swapSections(item, index, bySections[index+1], index+1)">
                            <v-icon color="#185EA9">arrow_downward</v-icon>
                          </v-btn>
                          <v-btn 
                            text
                            color="#185EA9" 
                            :disabled="loading" 
                            class="ml-2"
                            @click="editSection(item, index)">
                            {{ $t('wkt.admin.calendar.edit') }}
                          </v-btn>
                        </template>
                        <!-- <template v-slot:no-data>
                          <EmptyState 
                          class="pt-10"
                          :title="$t('wkt.admin.projects.calendar.by-section.no_items')" />
                        </template> -->
                      </v-data-table> 
                    </v-col>
                  </v-row>
                </v-container> 
            </v-form>
            <v-row style="margin-top: 10px;">
                <span style="font-size: 16px; font-weight: bold; color: #424242;">{{ $t('wkt.admin.projects.project.title_5') }}</span>
              </v-row>
            <EmployeesManager
              ref="employeeManager"
              :projectType="1"
              :tableLoading="tableLoading"
              :tableHeaders="tableHeaders"
              :tableItems="employees"
              :emptyStateTitle="$t('wkt.admin.teams.team.empty-state.title')"
              :emptyStateDescription="$t('wkt.admin.projects.calendar-wizard.empty-state.description')"
              tableHeight="calc(100vh - 430px)"
              @remove-all-employees="confirmRemoveAllProjectEmployees($event)"
              @add-employees="addProjectEmployees()"
              @remove-employee="removeProjectEmployee($event)"
            />
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#185EA9"
            text
            @click="onUpdate()" 
            style="font-size: 0.9em; font-weight: 400;">{{ $t("wkt.admin.common.dialog-buttons.update").toUpperCase() }}</v-btn>
          <v-btn
            text
            @click="close()"
            style="font-size: 0.9em; font-weight: 400;">{{ $t("wkt.admin.common.dialog-buttons.close").toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <LoadingDialog :loading="loading" />
    
    <ProjectCalendarBySectionDialog ref="dlgProjectCalendarBySection" />
    
    <TargetManagerDialog
      ref="dlgTargetManager"
      :filterByProfile="true"
      :title="$t('wkt.admin.teams.team.add_employees')"
      :targetLabel="$t('wkt.admin.employee-selector-window.target_placeholder')"
    />

    <ConfirmDialog
      ref="dlgConfirmRemoveAllProjectEmployees"
      :title="$t('wkt.admin.teams.team.remove-employees-confirm-dialog.title')"
      :message="confirmMessage"
      :titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
      :titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
      @confirmed="removeAllProjectEmployees()"
    />
    
    <InfoPlanningAssistantDialog
      ref="dlgInfoAddProjectEmployees"
      :title="$t('wkt.admin.projects.calendar-wizard.add-employees-in-projects.title')"
      :message="$t('wkt.admin.projects.calendar-wizard.add-employees-in-projects.description')"
      :titleOkWithEmployee="$t('wkt.admin.projects.calendar-wizard.add-employees-in-projects.ok-with-employees')"
      :titleOk="$t('wkt.admin.projects.calendar-wizard.add-employees-in-projects.ok')"
      :titleCancel="$t('wkt.admin.projects.calendar-wizard.add-employees-in-projects.cancel')"
      v-on:confirmed="confirmNoAdditionOfEmployees"
      v-on:confirmedAddEmployees="confirmAddingEmployees"
    />
    
    <v-snackbar v-model="showAlert" :timeout="alertTimeout" :color="alertColor">
      <span style="color: #ffffff;">{{ alertText }}</span>
      <v-btn text @click="showAlert = false">
        <span style="color: #ffffff;">{{ $t("wkt.admin.common.dialog-buttons.close") }}</span>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
// import EmptyState from "../../common/EmptyState.vue";
import EmployeesManager from "../../common/EmployeesManager.vue";
import LoadingDialog from "../../common/LoadingDialog.vue";
import TargetManagerDialog from "../dialogs/TargetManagerDialog.vue";
import ConfirmDialog from "../../common/ConfirmDialog.vue";
import InfoPlanningAssistantDialog from "../../common/InfoPlanningAssistantDialog.vue";
import ProjectCalendarBySectionDialog from "./ProjectCalendarBySectionDialog.vue";
import api from "../../../api/worktime.js";
import gwt from "../../../api/gwt.js";

export default {
  name: "ProjectCalendarAssistantDialog",
  mixins: [BaseModule],
  components: {
    // EmptyState,
    EmployeesManager,
    TargetManagerDialog,
    ConfirmDialog,
    InfoPlanningAssistantDialog,
    ProjectCalendarBySectionDialog,
    LoadingDialog
  },
  data() {
    return {
      loading: false,
      fromDateFormatted: null,
      fromDateIso: null,
      toDateFormatted: null,
      toDateIso: null,
      data: {},
      items: [],
      headers: [],
      departments: [],
      employees: [],
      tableLoading: false,
      tableHeaders: [],
      managers: [],
      managerIds: [],
      workplaces: [],
      errorMessages: "",
      showAlert: false,
      alertColor: "error",
      alertText: "",
      alertTimeout: 3000,
      showDialog: false,
      workdayDelete: false,
      weekdays: [],
      selectedWeekdays: [],
      planningType: 1,
      byDaysNotes: "",
      //bySectionsNotes: "",
      employeesNotInProjects: [],
      projectEmployeeId: [],
      byDays: [
        { periodicityInWeeks: 1, project: -1, calendar: -1, workplace: -1 },
      ],
      bySections: [
        //{ periodicityInDays: 1, project: -1, calendar: -1, workplace: -1 },
      ],
      projects: [],
      calendars: [],
      availableEmployees: [],
      confirmMessage: "",
      weekdaysErrorMessage: "",
      projectCache: {},
      addEmployeeInProjects: false,
      enableAdvancedPlanning: false,
    };
  },
  computed: {
    getPlanningTypeBySectionsText() {
      const text = this.$t('wkt.admin.projects.calendar-wizard.assistant_mode_advanced');
      if (this.enableAdvancedPlanning) {
        return text;
      }
      return `${text} (${this.$t('wkt.admin.projects.calendar-wizard.assistant_mode_advanced_warning')})`;
    }
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    // eslint-disable-next-line no-unused-vars
    onReveal(action, payload) {
      this.items = [];
      this.departments = [];
      this.weekdays = this.getWeekdayNames();
      this.errorMessages = "";
      this.weekdaysErrorMessage = "";
      this.projects = this.getProjects();
      this.calendars = this.getCalendars();
      this.workplaces = this.getWorkplaces();

      this.showDialog = true;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      
			const company = gwt.getSessionInformation().company;
			this.enableAdvancedPlanning = company.enableAdvancedPlanning;
      
      this.headers = [
        { text: this.$t("wkt.admin.projects.calendar-wizard.periodicity_days"), value: 'periodicityInDays', sortable: false },
        { text: this.$t("wkt.admin.projects.calendar-wizard.project_title"), value: 'project', sortable: false },
        { text: this.$t("wkt.admin.projects.calendar-wizard.calendar_title"), value: 'calendar', sortable: false },
        { text: this.$t("wkt.admin.projects.calendar-wizard.workplace_title"), value: 'workplace', sortable: false },
        { text: this.$t("wkt.admin.projects.calendar-wizard.company-notes"), value: 'notes', sortable: false },
        { text: '', value: 'actions', sortable: false, width: '200px' }
      ];

			this.tableHeaders = [
				{ text: this.$t('wkt.admin.projects.project.table.headers.name'), value: 'firstname', width: '25%', sortable: false },
				{ text: this.$t('wkt.admin.projects.project.table.headers.id_number'), value: 'idNumber', width: '15%', sortable: false },
				{ text: this.$t('wkt.admin.projects.project.table.headers.workplace'), value: 'workplaceName', width: '20%', sortable: false },
				{ text: this.$t('wkt.admin.projects.project.table.headers.department'), value: 'departmentName', width: '20%', sortable: false },
        { text: '', value: 'removeAction', width: '15%', sortable: false },
			];

      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const year = tomorrow.getFullYear();
      const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
      const day = String(tomorrow.getDate()).padStart(2, '0');

      this.fromDateIso = `${year}-${month}-${day}`;
      this.toDateIso = `${year}-${month}-${day}`;

      this.fromDateFormatted = this.formatISOStringDateToLocalDate(this.fromDateIso);
      this.toDateFormatted = this.formatISOStringDateToLocalDate(this.toDateIso);

      if (this.bySections.length === 0) {
        /*this.bySections.push({
          periodicityInDays: 1,
          project: -1,
          calendar: -1,
          workplace: -1,
        });*/
      }

      this.getDepartments();
    },
    getDepartments() {
      this.loading = true;
      if (gwt.getDepartments()) {
        this.departments = gwt.getDepartments();
        this.getAllManagers();
        this.loading = false;
        return;
      }

      api.getStaff(
        (data) => {
          this.loading = false;
          this.departments = data;
          this.getAllManagers();
        },
        (error) => {
          this.loading = false;
          this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    getAllManagers() {
      this.managers = [];

      for (let i = 0; i < this.departments.length; i++) {
        this.managers = [...this.managers, ...this.departments[i].employees];
      }

      this.managers.sort((a, b) => {
        const fullnameA = this.getEmployeeFullname(a).toLowerCase();
        const fullnameB = this.getEmployeeFullname(b).toLowerCase();
        if (fullnameA == fullnameB) return 0;
        if (fullnameA > fullnameB) return 1;
        return -1;
      });
    },
    getWorkplaces() {
      this.loading = true;
      api.getWorkPlaces(
        (data) => {
          this.loading = false;
          this.workplaces = data;
          const noModifyWorkplace = {
            id: -1,
            name: this.$t('wkt.admin.projects.calendar-wizard.no-modify-workplace'),
          };
          const resetWorkplace = {
            id: -2,
            name: this.$t('wkt.admin.projects.calendar-wizard.reset-workplace'),
          };
          this.workplaces.unshift(noModifyWorkplace, resetWorkplace);
        },
        (error) => {
          this.loading = false;
          this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    ////////////////////////////////////////////////////////////////
    // SECTIONS
    ////////////////////////////////////////////////////////////////
    getProjectNameBySection(projectId) {
      if (projectId === -1) {
        return this.$t('wkt.admin.projects.calendar-wizard.no-modify-project');
      }
      if (projectId === -2) {
        return this.$t('wkt.admin.projects.calendar-wizard.remove-project');
      }
      return this.projects.find(p => p.id === projectId).shortName;
    },
    getCalendarNameBySection(calendarId) {
      if (calendarId === -1) {
        return this.$t('wkt.admin.projects.calendar-wizard.no-modify-calendar');
      }
      if (calendarId === -2) {
        return this.$t('wkt.admin.projects.calendar-wizard.reset-calendar');
      }
      return this.calendars.find(c => c.id === calendarId).name;
    },
    getWorkplaceNameBySection(workplaceId) {
      if (workplaceId === -1) {
        return this.$t('wkt.admin.projects.calendar-wizard.no-modify-workplace');
      }
      if (workplaceId === -2) {
        return this.$t('wkt.admin.projects.calendar-wizard.reset-workplace');
      }
      return this.workplaces.find(w => w.id === workplaceId).name;
    },
    formatNotes(notes) {
      if (!notes) {
        return '';
      }
      return notes.replace(/\n/g, '<br>');
    },  
    addSection() {
      this.$refs.dlgProjectCalendarBySection.open(null, this.projects, this.calendars, this.workplaces, (operation) => {
        if (operation) {
          if (operation.type === 'add') {
            this.bySections.push(operation.data);          
          }
          if (operation.projectId) {
            this.data.id = operation.projectId;
          }
        }
      });
      /*this.bySections.push({
        periodicityInDays: 1,
        project: -1,
        calendar: -1,
        workplace: -1,
      });*/
    },
    swapSections(item1, index1, item2, index2) {
      this.$set(this.bySections, index1, item2);
      this.$set(this.bySections, index2, item1);
    },
    editSection(section, index) {
      this.$refs.dlgProjectCalendarBySection.open({ ...section }, this.projects, this.calendars, this.workplaces, (operation) => {
        if (operation) {          
          if (operation.type === 'edit') {
            this.$set(this.bySections, index, operation.data);
          }
          if (operation.type === 'delete') {
            this.bySections.splice(index, 1);
          }
          if (operation.projectId) {
            this.data.id = operation.projectId;
          }
        }
      });
    },
    /*removeSection(index) {
      this.bySections.splice(index, 1);
    },
    onProjectChange(projectId) {
      this.data.id = projectId;
    },*/
    ////////////////////////////////////////////////////////////////
    validate() {
      this.errorMessages = "";
      this.weekdaysErrorMessage = "";

      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.fromDateIso && this.toDateIso) {
        const dtStart = new Date(this.fromDateIso).getTime();
        const dtEnd = new Date(this.toDateIso).getTime();

        if (dtStart > dtEnd) {
          this.errorMessages = this.$t("wkt.admin.holidays.calendar.edit-holiday-window.new-record-window.errors.end_date_smaller");
          return false;
        }
      }

      if (this.planningType === this.constants.SHIFT_PLANNER_BY_DAYS && this.selectedWeekdays.length === 0) {
        this.weekdaysErrorMessage = this.$t("wkt.admin.calendar.wizard-window.weekday-required_error");
        return false;
      }

      if (this.employees.length <= 0) {
        this.doShowAlert({
          text: this.$t("wkt.admin.projects.calendar-wizard.not_selected_employees"),
          color: "error",
          timeout: 3000,
        });
        return false;
      }
      return true;
    },
    addProjectEmployees() {
      const employeesByDepartment = this.departments.flatMap(
        (department) => department.employees
      );

      this.$refs.dlgTargetManager.open(
        employeesByDepartment,
        this.data.id,
        (selectedEmployeeIds) => {
          const alreadyAddedEmployeeIds = this.employees.map(e => e.id);
          const newEmployeeIds = selectedEmployeeIds.filter(id => !alreadyAddedEmployeeIds.includes(id));

          // if (newEmployeeIds.length === 0) {
          //   return;
          // }

          const updatedEmployees = [...this.employees];

          const workplaceIds = [
            ...new Set(
              newEmployeeIds
                .map(id => employeesByDepartment.find(e => e.id === id)?.workplaceId)
                .filter(Boolean)
            ),
          ];
          const departmentIds = [
            ...new Set(
              newEmployeeIds
                .map(id => employeesByDepartment.find(e => e.id === id)?.departmentId)
                .filter(Boolean)
            ),
          ];

          const workplaceNamesMap = {};
          workplaceIds.forEach((id) => {
            workplaceNamesMap[id] = this.getWorkplaceNameById(id);
          });

          const departmentNamesMap = {};
          departmentIds.forEach((id) => {
            departmentNamesMap[id] = this.getDepartmentNameById(id);
          });

          newEmployeeIds.forEach((id) => {
            const employee = employeesByDepartment.find(e => e.id === id);
            if (employee) {
              updatedEmployees.push({
                ...employee,
                projectId: null,
                workplaceName: workplaceNamesMap[employee.workplaceId],
                departmentName: departmentNamesMap[employee.departmentId],
              });
            }
          });
          this.employees = updatedEmployees;
          this.tableLoading = false;

          // let me = this;
          // this.$nextTick(() => {
          //   me.scrollTo();
          // });

          let message = this.$t("wkt.admin.projects.project.num_employees_added");
          message = message.replace("%d", `${newEmployeeIds.length}`);
          this.doShowAlert({ text: message, color: "success", timeout: 3000 });
        }
      );
    },
    removeProjectEmployee(employeeId) {
      this.employees = this.employees.filter(e => e.id !== employeeId);
      // let me = this;
      // this.$nextTick(() => {
      //   me.scrollTo();
      // });
    },
    confirmRemoveAllProjectEmployees() {
      const numEmployeesToRemove = this.employees.length;
      this.confirmMessage = this.$t("wkt.admin.projects.project.remove-employees-confirm-dialog.text");
      this.confirmMessage = this.confirmMessage.replace("%d", `${numEmployeesToRemove}`);

      this.$refs.dlgConfirmRemoveAllProjectEmployees.confirm();
    },
    removeAllProjectEmployees() {
      this.employees = [];
      // let me = this;
      // this.$nextTick(() => {
      //   me.scrollTo();
      // });
    },
    getProjects() {
      this.loading = true;
      api.getProjects(
        (res) => {
          this.loading = false;
          this.projects = res.filter(project => project.projectType === 0);
          const noModifyProject = { id: -1, shortName: this.$t('wkt.admin.projects.calendar-wizard.no-modify-project') };
          const removeProject = { id: -2, shortName: this.$t('wkt.admin.projects.calendar-wizard.remove-project') };
          this.projects.unshift(noModifyProject, removeProject);
        },
        (error) => {
          this.loading = false;
          this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    getCalendars() {
      this.loading = true;
      api.getCalendars(
        (res) => {
          this.loading = false;
          this.calendars = res;
          const noModifyCalendar = { id: -1, name: this.$t('wkt.admin.projects.calendar-wizard.no-modify-calendar') };
          const resetCalendar = { id: -2, name: this.$t('wkt.admin.projects.calendar-wizard.reset-calendar') };
          this.calendars.unshift(noModifyCalendar, resetCalendar);
        },
        (error) => {
          this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
        }
      );
    },
    doShowAlert(payload) {
      this.alertText = payload.text;
      this.alertColor = payload.color;
      this.alertTimeout = payload.timeout;
      this.showAlert = true;
    },
    convertToDateFormat(dateString) {
      const date = new Date(dateString);
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    },
    onUpdate() {
      if (!this.validate()) {
        return;
      }

      this.selectedProjects =
        this.planningType === this.constants.SHIFT_PLANNER_BY_DAYS
          ? this.byDays.map((day) => day.project)
          : this.bySections.map((section) => section.project);

      const validProjects = this.selectedProjects.filter(
        (projectId) => projectId !== -1 && projectId !== -2
      );

      this.employeesNotInProjects = [];
      let remainingCalls = validProjects.length;

      if (remainingCalls === 0) {
        this.handleDialog();
        return;
      }

      validProjects.forEach((projectId) => {
        const alreadyAddedEmployeeIds = this.employees.map((e) => e.id);

        api.getFullProjectsEmployeesByProjectId(
          projectId,
          (res) => {
            const projectEmployeeIds = res.map((e) => e.employeeId);

            // Filtrar los empleados no encontrados en el proyecto
            const notInProject = alreadyAddedEmployeeIds.filter(
              (id) => !projectEmployeeIds.includes(id)
            );

            this.employeesNotInProjects.push(...notInProject.map((id) => ({ employeeId: id, projectId })));

            // Disminuir el contador y verificar si es el último
            remainingCalls--;
            if (remainingCalls === 0) {
              this.handleDialog();
            }
          },
          (error) => {
            this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
          }
        );
      });
    },
    handleDialog() {
      if (this.employeesNotInProjects.length > 0) {
        this.$refs.dlgInfoAddProjectEmployees.confirm(this.employeesNotInProjects);
      } else {
        this.confirmNoAdditionOfEmployees();
      }
    },
    confirmAddingEmployees() {
      this.addEmployeeInProjects = true;
      this.executeStoreProjectCalendar();
    },
    confirmNoAdditionOfEmployees() {
    this.addEmployeeInProjects = false;
      this.executeStoreProjectCalendar();
    },
    executeStoreProjectCalendar() {
      const fromDate = this.convertToDateFormat(this.fromDateIso);
      const toDate = this.convertToDateFormat(this.toDateIso);
      const employeeIds = this.employees.map((e) => e.id);

      let shifts = [];
      if (this.planningType === this.constants.SHIFT_PLANNER_BY_DAYS) {
        shifts = this.byDays.map((day) => ({
          calendarId: day.calendar,
          employees: employeeIds,
          fromDate: fromDate,
          toDate: toDate,
          notes: this.byDaysNotes,
          periodicityInWeeks: day.periodicityInWeeks,
          periodicityInDays: null,
          projectId: day.project,
          workplaceId: day.workplace,
          planningType: 1,
          monday: this.selectedWeekdays.includes("L"),
          tuesday: this.selectedWeekdays.includes("M"),
          wednesday: this.selectedWeekdays.includes("X"),
          thursday: this.selectedWeekdays.includes("J"),
          friday: this.selectedWeekdays.includes("V"),
          saturday: this.selectedWeekdays.includes("S"),
          sunday: this.selectedWeekdays.includes("D"),
          workdayDelete: this.workdayDelete
        }));
      } else if (this.planningType === this.constants.SHIFT_PLANNER_BY_SECTIONS) {
        shifts = this.bySections.map((section) => ({
          calendarId: section.calendar,
          employees: employeeIds,
          fromDate: fromDate,
          toDate: toDate,
          notes: section.notes,
          //notes: this.bySectionsNotes,
          periodicityInWeeks: null,
          periodicityInDays: section.periodicityInDays,
          projectId: section.project,
          workplaceId: section.workplace,
          planningType: 0,
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null,
        }));
      }

      this.data = {
        fromDate: fromDate,
        toDate: toDate,
        planningType: this.planningType,
        shifts: shifts,
        addEmployeesInProjects: this.addEmployeeInProjects,
      };
      this.loading = true;

      api.storeProjectCalendar(
        this.data,
        (res) => {
          this.loading = false;
        
          if (res.resultCode==100)
          {
            this.doShowAlert({ text: this.$t('wkt.admin.common.task_in_background'), color: "success", timeout: 3000 });
            return;
          }

          if (res.resultCode==-100)
          {
            this.doShowAlert({ text: this.$t('wkt.admin.common.task_in_progress_error'), color: "error", timeout: 3000 });
            return;
          }
          
          this.doShowAlert({ text: this.$t('wkt.admin.projects.calendar-wizard.update-message-ok'), color: "success", timeout: 3000 });
 
        },
        (error) => {
          this.loading = false;
          this.showDialog = false;
          this.$log.error(error);
          this.doShowAlert({ text: error.message, color: "error", timeout: 3000 });
        }
      );
      gwt.fireEvent('UpdateProjectCalendarEvent');
    },
    close() {
			this.showDialog = false;
      this.selectedWeekdays = [];
      this.workdayDelete = false;
      this.fromDateFormatted = null;
      this.fromDateIso = null;
      this.toDateFormatted = null;
      this.toDateIso = null;
      this.planningType = 1;
      this.byDaysNotes = "";
      this.bySectionsNotes = "";
      this.employees = [];
      this.byDays = [
        { periodicityInWeeks: 1, project: -1, calendar: -1, workplace: -1 },
      ];
      this.bySections = [
        /*{ periodicityInDays: 1, project: -1, calendar: -1, workplace: -1 },*/
      ];
      gwt.fireEvent('UpdateProjectCalendarEvent');
		},
    // scrollTo() {
    //   this.$refs.employeeManager.$el.scrollIntoView();
    // },
  },
  
  watch: {
    fromDateIso(val) {
      this.fromDateFormatted = this.formatOnlyDate(val);
    },
    toDateIso(val) {
      this.toDateFormatted = this.formatOnlyDate(val);
    },
  },
};
</script>